import { useEffect } from "react";

import { useLocation } from "@swa-ui/browser";

import { fireViewSeatClickAnalytics } from "./airSeatClickActions";
import { AIR_SEATS_ROUTES } from "./defines/airSeatRoutes";

export function useViewSeatsAnalytics(
  seats,
  flightSegments,
  selectedSegment,
  interactive,
  rrChaseCardType
) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === AIR_SEATS_ROUTES.view) {
      if (
        Object?.keys(seats).length !== 0 &&
        Object?.values(seats)?.every((seat) => seat.loading === false) &&
        !interactive
      ) {
        fireViewSeatClickAnalytics(seats, flightSegments, selectedSegment);
      }
    }
  }, [selectedSegment, seats, rrChaseCardType]);
}
